export const companyToOption = company => ({
  label : company?.name,
  value : company?.id,
})
